import { forwardRef, type TextareaHTMLAttributes } from 'react'

// One editor for owner and guest composers, including mobile sizing and focus.
const ComposerTextInput = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement> & { scale?: number }>(
  function ComposerTextInput({ scale = 1, style, ...props }, ref) {
    return <textarea ref={ref} rows={1} placeholder="Message…"
      className="agentchat-composer-textarea min-w-0 flex-1 resize-none bg-transparent border-0 px-1 py-2 focus:outline-none placeholder:text-stone-500 dark:placeholder:text-stone-400"
      style={{ fontSize: `${14 * scale}px`, lineHeight: 1.5, textSizeAdjust: 'none', WebkitTextSizeAdjust: 'none', minHeight: 36, maxHeight: 220, ...style }}
      {...props} />
  },
)
export default ComposerTextInput
